import { render } from "./Restrito.vue?vue&type=template&id=644b7f37"
import script from "./Restrito.vue?vue&type=script&lang=js"
export * from "./Restrito.vue?vue&type=script&lang=js"

import "./Restrito.vue?vue&type=style&index=0&id=644b7f37&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__